import React, { useEffect, useRef } from 'react';
import Swiper from 'swiper'
import { Pagination, EffectFade, Autoplay } from 'swiper/modules';
import styles from './masthead.module.scss'
import { placeholderImg } from "../icons/icon-names";
import BaseContainer from "../BaseContainer";
import MastheadContentUI from "./MastheadContentUI";

const Masthead = (props) => {
  const swiperElRef = useRef(null);
  const {testId, autoplay, delay, size, backgroundwhite} = props
  useEffect(() => {
    new Swiper(swiperElRef.current, {
      modules: [Pagination, EffectFade, Autoplay],
      speed: 800,
      effect: 'slide',
      pagination: {
        el: swiperElRef.current.querySelector('.swiper-pagination'),
        clickable: true,
        lockClass: 'hidden'
      },
      autoplay: (autoplay && delay > 0 && delay !== undefined) ? {
        delay: delay * 1000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true
      } : false
    });
  }, [autoplay, delay]);


  const handleMastheadSize = () =>{
    let sizeClass = "";
    switch (size) {
      case "large":
        sizeClass = "h-[550px] lg:h-[650px]";
        break;
      case "medium":
        sizeClass = "h-[439px]";
        break;
      case "small":
        sizeClass = "h-[323px] lg:h-[259px]";
        break;
      default:
        sizeClass = "h-[439px]";
    }
    return sizeClass;
  }
  
  const isAlertBanner = document.querySelectorAll('em-alert-banner');
  
  return (
    <div className={`swiper ${backgroundwhite ? "bg-white":""} ${isAlertBanner.length ? "pb-[25px] lg:pb-[0]" : ""}`} id={testId} ref={swiperElRef}>
      <div className="swiper-wrapper">
        {
          props.data?.map((item) => (
            <div className="swiper-slide" key={item.id}>
              <div className={`relative flex items-center ${handleMastheadSize()}`}>
                <BaseContainer className="relative text-white z-10 -mb-11 lg:-mb-[72px]">
                  <MastheadContentUI item={item} />
                </BaseContainer>

                <picture>
                  <source media="(min-width: 1024px)" srcSet={item.banner?.desktop || placeholderImg} />
                  <source media="(max-width: 1023px)" srcSet={item.banner?.mobile || placeholderImg} />
                  <img src={item.banner?.desktop || placeholderImg} alt={item.heading || ''} rel="preload" className="absolute object-cover object-center w-full h-full left-0 top-0" />
                </picture>

                <div className="absolute w-full h-full left-0 pointer-events-none bg-gradient-to-t from-black/50 lg:bg-gradient-to-r lg:from-black/50">
                  <div className="bg-gradient-to-r from-black/0 to-black/50 w-full h-full"></div>
                </div>
              </div>
            </div>
          ))
        }

      </div>
      <BaseContainer className="h-0">
        <div className={`swiper-pagination absolute lg:relative flex justify-end left-4 lg:left-auto bottom-16 ${size === "medium" ? "lg:bottom-24" : "lg:bottom-32"} z-20 ${styles.pagination}`}></div>
      </BaseContainer>
    </div>
  )

};
export default Masthead;